module.exports = __webpack_public_path__ + "img/539.4b1f50a6.jpg";